<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="u9kHI5QBZoMQDOLrRaN6tX8">Chapter One</p>
<p class="FIRSTPARAGRAPH">“Hello? Is anyone there?”</p>
<p class="Normal">The echo of the woman’s voice was her only reply.</p>
<p class="Normal"><span class="italics _idGenCharOverride-1">Where the hell am I?</span> she wondered, as frenzy riddled her brain. “Hello?”</p>
<p class="Normal">She attempted to move. But couldn’t. Her head was restrained. As were her wrists and ankles. <span class="italics _idGenCharOverride-1">Something smooth, </span>she thought.<span class="italics _idGenCharOverride-1"> And strong. Cloth?</span> “Oh, my God! It’s rope!”</p>
<p class="Normal">Heart racing, she caught sight of a shadowy figure that appeared to be moving above. “Hey you! You! Up there. Please help me!”</p>
<p class="Normal">Silence.</p>
<p class="Normal">It felt as though she were lying on moist sand. Cold moist sand. A glimpse of her left nipple fueled her growing hysteria.</p>
<p class="Normal"><span class="italics _idGenCharOverride-1">Why am I naked? </span>Her adrenalin surged.<span class="italics _idGenCharOverride-1"> Jesus Christ! . . . What’s happening to me?</span></p>
<p class="Normal">The figure above was still moving.</p>
<p class="Normal">As stomach acid refluxed into her throat, something slimy slithered across her abdomen before sliding down between her legs. She opened wide her eyes, willing herself to awaken from her nightmare only to have panic fill her for her gaze climbed walls of clay that formed a rectangle open at its top.<span class="italics _idGenCharOverride-1"> </span>She at its base.</p>
<p class="Normal">She let loose a bestial scream. Blinked rapidly, and screamed again.</p>
<p class="Normal">Willows, visible through the aperture of the grave, swayed against a cloudless sky, deaf to her howling. Indifferent to her plight.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chap_01.vue?a99eb822